import { useContext } from 'react';
import Constants from '@usas/ui-web/utils/Constants';

import { OmeMeetOrgUnitEntryRosterPermissionsStateContext } from './OmeMeetOrgUnitEntryRosterPermissionsContextProvider';

import OmeMeetOrgUnitEntryRosterPermissionsData from './OmeMeetOrgUnitEntryRosterPermissionsData';

const useOmeMeetOrgUnitEntryRosterPermissionsData = () => {
  const [omeMeetOrgUnitEntryRosterPermissionsState, setOmeMeetOrgUnitEntryRosterPermissionsState] = useContext(OmeMeetOrgUnitEntryRosterPermissionsStateContext);

  const getOmeMeetOrgUnitEntryRosterPermissions = (omeMeetOrgUnitEntryId) => {
    OmeMeetOrgUnitEntryRosterPermissionsData.getOmeMeetOrgUnitEntryRosterPermissionsData(omeMeetOrgUnitEntryId, omeMeetOrgUnitEntryRosterPermissionsState, setOmeMeetOrgUnitEntryRosterPermissionsState);
  };

  const putOmeMeetOrgUnitEntryRosterPermissions = (omeMeetOrgUnitEntryId, omeMeetOrgUnitEntryRosterPermissionsObj) => {
    OmeMeetOrgUnitEntryRosterPermissionsData.putOmeMeetOrgUnitEntryRosterPermissionsData(omeMeetOrgUnitEntryId, omeMeetOrgUnitEntryRosterPermissionsObj, omeMeetOrgUnitEntryRosterPermissionsState, setOmeMeetOrgUnitEntryRosterPermissionsState);
  };

  const clearOmeMeetOrgUnitEntryRosterPermissionsObjData = () => {
    setOmeMeetOrgUnitEntryRosterPermissionsState({
      ...omeMeetOrgUnitEntryRosterPermissionsState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {},
      omeMeetOrgUnitEntryId: Constants.DEFAULT_ID,
      message: ''
    });
  };


  const confirmSaveOmeMeetOrgUnitEntryRosterPermissions = () => {
    setOmeMeetOrgUnitEntryRosterPermissionsState({
      ...omeMeetOrgUnitEntryRosterPermissionsState,
      isSaved: false
    });
  };

  return {
    omeMeetOrgUnitEntryRosterPermissionsState,
    setOmeMeetOrgUnitEntryRosterPermissionsState,
    getOmeMeetOrgUnitEntryRosterPermissions,
    putOmeMeetOrgUnitEntryRosterPermissions,
    clearOmeMeetOrgUnitEntryRosterPermissionsObjData,
    confirmSaveOmeMeetOrgUnitEntryRosterPermissions
  };
};

export default useOmeMeetOrgUnitEntryRosterPermissionsData;